/* eslint-disable eqeqeq */
import { Formik } from "formik";
import { useEffect, useState } from "react";
import Spin from "../../../components/Spin";
import { Label } from "../../../components/ui/label";
import CustomLabelText from "../../../components/CustomLabelText";
import { Input } from "../../../components/ui/input";
import { API, fileUpload, get } from "../../../config";
import { PhoneInput } from "../../../components/ui/phone-input";
import SearchSelect from "../../../components/SearchSelect";
import { useRoleList } from "../../../lib/OptionsAPI";
import { Loader2 } from "lucide-react";
import { Button } from "../../../components/ui/button";
import { useOrganization } from "../../../lib/context/OrganisationContext";
import { MultiSelect } from "../../../components/SearchMultiSelect";
import OfficeSelect from "../../../components/OfficeSelect";
import { formatedPostalCode, formatOfficeName } from "../../../lib/Misc";
import { AddUserSchema } from "../../../lib/Validation";
import { Switch } from "../../../components/ui/switch";
import MultiFileUpload from "../../../components/MultiFileUpload";
import moment from "moment";
import { Step, Stepper } from "../../../components/ui/stepper";
import VerificationStep from "../../../components/Assessment_KYC/VerificationStep";
import { useStateList } from "../../Auth/SignUpHelper";
import { normalizeVerificationData } from "../../../lib/utils";
// import AssessmentStep from "../../../components/Assessment_KYC/AssessmentStep";

const AddEditUser = ({
  id,
  toggleShowAddEditUser,
  edit,
  setEdit,
  fetchUserData,
  orgId,
  amlCTFEnable = false,
  onlyKyc = false,
}) => {
  const [userData, setUserData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [files, setFiles] = useState();

  const [officeLoading, setOfficeLoading] = useState(false);
  const [officeListing, setOfficeListing] = useState([]);
  const [officeList, setOfficeList] = useState([]);
  const [userId, setUserId] = useState(id);

  const { organizationData } = useOrganization();

  const { stateLoading, stateList = [] } = useStateList();
  const stateListing = stateList?.map((item) => {
    const { id: value, name, short_name, ...rest } = item;
    return { label: name + ` (${short_name})`, value, ...rest };
  });
  const state = stateListing?.find(
    (item) => item?.value === (userData?.state_id ? userData?.state_id : ""),
  )?.value;

  let stepsData =
    edit && amlCTFEnable
      ? !onlyKyc
        ? [
            {
              label: `Users Details`,
            },
            // {
            //   label: "Risk Assessment",
            // },
            {
              label: "Verifications",
            },
          ]
        : [
            // {
            //   label: "Risk Assessment",
            // },
            {
              label: "Verifications",
            },
          ]
      : [
          {
            label: `Users Details`,
          },
        ];

  // const [sectionType, setSectionType] = useState(false);
  const [verificationMethods, setVerificationMethods] = useState([]);
  const [verificationTypes, setVerificationTypes] = useState([]);
  const [currentStep, setCurrentStep] = useState(0);

  const fetchVerificationMethodsTypes = async () => {
    try {
      setLoading(true);
      const { data } = await get(`${API.VERFICATION_TYPES}`);
      setVerificationMethods(data?.verification_methods);
      setVerificationTypes(data?.document_types);
      setLoading(false);
    } catch (e) {
      setVerificationMethods([]);
      setVerificationTypes([]);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVerificationMethodsTypes();
  }, []);

  async function fetchData() {
    try {
      setLoading(true);
      const reponse = await get(`${API.USER}/` + userId);

      let data = reponse?.data?.data;
      setFiles(data?.files);
      if (data?.office?.state_id ? data?.office?.state_id : false) {
        if (data?.office?.suburb_id ? data?.office?.suburb_id : false) {
          setOfficeListing([
            data?.office
              ? {
                  ...data?.office,
                  value: data?.office.id,
                  label: formatOfficeName(
                    data?.office?.street,
                    data?.office?.suburb,
                  ),
                }
              : {},
          ]);
        }
      }
      data?.kyc?.verifications?.length > 0 &&
        data.kyc.verifications?.map((item) => {
          item.mobile = data?.mobile
            ? data?.mobile[0] === "+"
              ? data?.mobile
              : `+${data?.mobile}`
            : "";
          item.verified_status = item.verified === 1 ? true : false;
          item.date_verified = item.date_verified
            ? moment(item.date_verified, "DD-MM-YYYY")
            : null;
          item.verified_by = item?.verified_by_id ? item?.verified_by_id : "";
          item.type = item?.verification_document_type_id
            ? item?.verification_document_type_id
            : "";
          item.dynamicFields = normalizeVerificationData(
            item?.data,
            item?.verification_document_type,
            item?.verification_document_type_id,
            setVerificationTypes,
          );
          return item;
        });
      if (data?.type == "2" && data?.entity_type != "1") {
        stepsData = stepsData?.filter((item) => item.label !== "Verifications");
      }
      setCurrentStep(
        data?.current_step
          ? data?.current_step > stepsData?.length - 1
            ? 0
            : data?.current_step
          : 0,
      );

      setUserData(data);
      setLoading(false);
    } catch (e) {
      setLoading(false);
      setUserData(null);
    }
  }

  useEffect(() => {
    if (officeList) {
      let officeTempListing = officeList?.map((item) => ({
        ...item,
        value: item.id,
        label: formatOfficeName(item?.street, item?.suburb),
      }));
      setOfficeListing(officeTempListing || []);
    } else {
      setOfficeListing([]);
    }
  }, [officeList]);

  useEffect(() => {
    if (edit) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  // Role
  const { roleLoading, roleList = [] } = useRoleList();
  const roleListing = roleList ? roleList : [];

  // const orgID = organizationData?.organizationList?.find(
  //   (item) => item?.value === userData?.organization_ids
  // )?.value;

  const handleFormSubmit = async (value) => {
    const formData = new FormData();
    value.mobile = value?.mobile ? `${value?.mobile}`.replace(/ /g, "") : "";

    formData.append("first_name", value?.first_name ? value?.first_name : "");
    formData.append("last_name", value?.last_name ? value?.last_name : "");
    formData.append("mobile", value?.mobile ? value?.mobile : "");
    formData.append("email", value?.email ? value?.email : "");
    formData.append("role_id", value?.role_id ? value?.role_id : "");
    formData.append("office_id", value?.office_id ? value?.office_id : "");

    formData.append("is_compliance", value?.is_compliance ? 1 : 0);
    formData.append("is_senior_manager", value?.is_senior_manager ? 1 : 0);

    formData.append("current_step", currentStep + 1);

    formData.append(
      "dob",
      value?.dob ? moment(value?.dob)?.format("DD-MM-YYYY") : "",
    );

    formData.append("street", value?.street ? value?.street : "");
    formData.append("state_id", value?.state_id ? value?.state_id : "");
    formData.append("suburb_id", value?.suburb_id ? value?.suburb_id : "");
    formData.append(
      "postal_code",
      value?.postal_code ? value?.postal_code : "",
    );

    formData.append("type", value?.type ? value?.type : "1");

    if (files?.length > 0) {
      for (let fileIndex = 0; fileIndex < files?.length; fileIndex++) {
        if (files[fileIndex]?.id) {
          formData.append(`file_ids[${fileIndex}]`, files[fileIndex]?.id);
        }
        formData.append(
          `files[${fileIndex}]`,
          files[fileIndex]?.url
            ? files[fileIndex]?.url
            : files[fileIndex]?.file,
        );
      }
    }

    for (let i = 0; i < value?.organization_id?.length; i++) {
      formData.append(`organization_ids[${i}]`, value?.organization_id[i]);
    }

    formData.append("risk", value?.risk ? value?.risk : "0");
    formData.append(
      "cdd_customer_type",
      value?.cdd_customer_type ? value?.cdd_customer_type : "0",
    );

    formData.append("cdd", value?.cdd ? value?.cdd : "0");
    formData.append("notes", value?.notes ? value?.notes : "");
    formData.append("ntf_note", value?.ntf_note ? value?.ntf_note : "");
    formData.append(
      "risk_assessment_id",
      value?.risk_assessment_id ? value?.risk_assessment_id : "",
    );

    formData.append(
      "compliance_manager_id",
      value?.compliance_manager_id ? value?.compliance_manager_id : "",
    );

    formData.append("reason", value?.reason ? value?.reason : "");

    if (value.verifications?.length) {
      value.verifications.forEach((row, index) => {
        formData.append(`verifications[${index}][method]`, row.method ?? "");

        if (row.id) {
          formData.append(`verifications[${index}][id]`, row.id ?? "");
        }

        formData.append(`verifications[${index}][type]`, row.type ?? "");

        formData.append(
          `verifications[${index}][date_verified]`,
          moment.isMoment(row.date_verified)
            ? row.date_verified.format("DD-MM-YYYY")
            : row.date_verified instanceof Date
              ? moment(row.date_verified).format("DD-MM-YYYY")
              : row.date_verified || "",
        );
        formData.append(
          `verifications[${index}][document_number]`,
          row.document_number ?? "",
        );

        formData.append(
          `verifications[${index}][verified_by]`,
          typeof row.verified_by === "object" && row.verified_by !== null
            ? row.verified_by.id || row.verified_by.verified_by_id || ""
            : row.verified_by || "",
        );
        formData.append(
          `verifications[${index}][verified]`,
          row.verified ?? "",
        );

        formData.append(
          `verifications[${index}][key]`,
          verificationTypes?.find((item) => item.id === row?.type)?.key &&
            row?.type
            ? verificationTypes?.find((item) => item.id === row?.type)?.key
            : "",
        );

        if (row.method === 3) {
          // ▪ Dynamic Fields
          if (row.dynamicFields) {
            Object.keys(row.dynamicFields).forEach((key) => {
              let value = row.dynamicFields[key];

              // If value is moment
              if (moment.isMoment(value)) {
                value = value.format(
                  value._f === "MM-YYYY" ? "MM-YYYY" : "DD-MM-YYYY",
                );
              }

              // If value is JS Date
              else if (value instanceof Date) {
                value = moment(value).format("DD-MM-YYYY");
              }

              // If value is already MM-YYYY
              else if (
                typeof value === "string" &&
                /^\d{2}-\d{4}$/.test(value)
              ) {
                // eslint-disable-next-line no-self-assign
                value = value;
              }

              formData.append(
                `verifications[${index}][fields][${key}]`,
                value ?? "",
              );
            });
          }
        }
      });
    }

    if (edit) {
      formData.append("_method", "put");
    }
    try {
      setLoading(true);
      const { data } = await fileUpload(
        `${API.USER}${edit ? `/${userId}` : ""}`,
        formData,
      );
      setLoading(false);
      if (!edit && data && amlCTFEnable) {
        setUserId(data?.data?.id);
        setEdit(true);
      }
      if (data?.data) {
        data?.data?.kyc?.verifications?.length > 0 &&
          data?.data.kyc.verifications?.map((item) => {
            item.mobile = data?.data?.mobile
              ? data?.data?.mobile[0] === "+"
                ? data?.data?.mobile
                : `+${data?.data?.mobile}`
              : "";
            item.verified_status = item.verified === 1 ? true : false;
            item.date_verified = item.date_verified
              ? moment(item.date_verified, "DD-MM-YYYY")
              : null;
            item.verified_by = item?.verified_by_id ? item?.verified_by_id : "";
            item.type = item?.verification_document_type_id
              ? item?.verification_document_type_id
              : "";
            item.dynamicFields = normalizeVerificationData(
              item?.data,
              item?.verification_document_type,
              item?.verification_document_type_id,
              setVerificationTypes,
            );
            return item;
          });
        setUserData(data?.data);
      }
      if (data?.data?.type == "2" && data?.data?.entity_type != "1") {
        stepsData = stepsData?.filter((item) => item.label !== "Verifications");
      }
      setCurrentStep(Number(Number(currentStep) + 1));

      (edit || !setEdit) &&
      amlCTFEnable &&
      stepsData?.length - 1 === currentStep
        ? toggleShowAddEditUser()
        : stepsData?.length - 1 === currentStep && toggleShowAddEditUser();

      if (data) {
        // toggleShowAddEditUser();
        fetchUserData();
      }
      return data?.data;
    } catch (error) {
      setLoading(false);
    }
  };
  return (
    <Formik
      initialValues={{
        organization_id: userData?.organization_ids
          ? userData?.organization_ids
          : [orgId],
        first_name: userData?.first_name,
        last_name: userData?.last_name,
        mobile: userData?.mobile,
        email: userData?.email,
        office_id: userData?.office_id ? userData?.office_id : "",
        role_id: userData?.role_id ? userData?.role_id : "",
        is_compliance: userData?.is_compliance ? true : false,
        is_senior_manager: userData?.is_senior_manager ? true : false,
        dob: userData?.dob ? moment(userData?.dob, "DD-MM-YYYY") : "",
        type: userData?.type ? userData?.type : "",
        cdd_customer_type: userData?.kyc?.cdd_customer_type
          ? userData?.kyc?.cdd_customer_type
          : "0",
        cdd: userData?.kyc?.cdd ? userData?.kyc?.cdd : "0",
        risk: userData?.kyc?.risk ? userData?.kyc?.risk : "0",
        notes: userData?.kyc?.notes ? userData?.kyc?.notes : "",
        ntf_note: userData?.kyc?.ntf_note ? userData?.kyc?.ntf_note : "",
        street: userData?.street ? userData?.street : "",
        state_id: state,
        suburb_id: userData?.suburb_id,
        postal_code: userData?.postal_code
          ? formatedPostalCode(userData?.postal_code)
          : "",

        verifications: userData?.kyc?.verifications
          ? userData?.kyc?.verifications
          : [
              {
                method: "",
                type: "",
                document_number: "",
                date_verified: "",
                verified_by: "",
                verified: "",
                dynamicFields: {},
                mobile: userData?.mobile
                  ? userData?.mobile[0] === "+"
                    ? userData?.mobile
                    : `+${userData?.mobile}`
                  : "",
              },
            ],

        risk_assessment_id: userData?.kyc?.risk_assessment?.id
          ? userData?.kyc?.risk_assessment?.id
          : "",

        compliance_manager_id: userData?.kyc?.risk_profile_changes
          ?.compliance_manager_id
          ? userData?.kyc?.risk_profile_changes?.compliance_manager_id
          : "",
        compliance_manager_name: userData?.kyc?.risk_profile_changes
          ?.compliance_manager_name
          ? userData?.kyc?.risk_profile_changes?.compliance_manager_name
          : "",
        reason: userData?.kyc?.risk_profile_changes?.reason
          ? userData?.kyc?.risk_profile_changes?.reason
          : "",
        is_kyc: true,
      }}
      enableReinitialize={true}
      onSubmit={handleFormSubmit}
      validateOnBlur={true}
      validateOnChange={true}
      validationSchema={AddUserSchema}
    >
      {({
        values,
        errors,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isValid,
        validateField,
        setTouched,
      }) => (
        <>
          {loading && <Spin expand={true} fullscreen={true} />}
          <form
            onSubmit={handleSubmit}
            noValidate
            className="entry-section md:m-0 m-5"
          >
            <div className="form-box overflow-y-auto overflow-x-hidden max-h-[80vh] p-4 border rounded-lg">
              {edit && onlyKyc && userData ? (
                <p>
                  <b>{"Name: "}</b>
                  {userData?.first_name
                    ? userData?.first_name + " " + userData?.last_name
                    : userData?.last_name
                      ? userData?.last_name
                      : ""}
                </p>
              ) : (
                ""
              )}
              <Stepper
                key={currentStep}
                initialStep={currentStep}
                steps={stepsData}
                // onClickStep={(step, setStep) => {
                //   edit && setStep(step);
                // }}
                className="justify-center mb-2"
              >
                {!onlyKyc && (
                  <Step
                    label={`Users Details`}
                    horizontalStepClassName={"flex flex-col gap-2 font-bold"}
                  >
                    <>
                      {!onlyKyc && (
                        <div className="grid gap-4">
                          <div className="grid md:grid-cols-2 gap-4">
                            <div className="grid gap-2">
                              <Label htmlFor="first_name">
                                <CustomLabelText
                                  required={false}
                                  labelText="First Name"
                                  errorField={errors?.first_name}
                                />
                              </Label>
                              <Input
                                id="first_name"
                                type="text"
                                name="first_name"
                                value={
                                  values?.first_name ? values?.first_name : ""
                                }
                                onChange={handleChange}
                                onBlur={handleBlur}
                                autoComplete="off"
                                onKeyPress={(e) => {
                                  e.which === 13 && e.preventDefault();
                                }}
                                className={
                                  errors?.first_name &&
                                  `focus-visible:ring-red-500 border-red-500`
                                }
                              />
                            </div>
                            <div className="grid gap-2">
                              <Label htmlFor="last_name">
                                <CustomLabelText
                                  required={true}
                                  labelText="Last Name"
                                  errorField={errors?.last_name}
                                />
                              </Label>
                              <Input
                                id="last_name"
                                type="text"
                                name="last_name"
                                value={
                                  values?.last_name ? values?.last_name : ""
                                }
                                onChange={handleChange}
                                onBlur={handleBlur}
                                autoComplete="off"
                                onKeyPress={(e) => {
                                  e.which === 13 && e.preventDefault();
                                }}
                                className={
                                  errors?.last_name &&
                                  `focus-visible:ring-red-500 border-red-500`
                                }
                              />
                            </div>

                            <div className="grid gap-2">
                              <Label htmlFor="email">
                                <CustomLabelText
                                  required={true}
                                  labelText="Email"
                                  errorField={errors?.email}
                                />
                              </Label>
                              <Input
                                id="email"
                                type="email"
                                placeholder="m@example.com"
                                required
                                autoComplete="off"
                                name="email"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values?.email}
                                className={
                                  errors?.email &&
                                  `focus-visible:ring-red-500 border-red-500`
                                }
                              />
                            </div>

                            <div className="grid gap-2">
                              <Label htmlFor="phone">
                                <CustomLabelText
                                  required={false}
                                  labelText="Mobile No."
                                  errorField={errors?.mobile}
                                />
                              </Label>
                              <PhoneInput
                                onChange={(e) => {
                                  setFieldValue("mobile", e);
                                }}
                                value={values?.mobile}
                                defaultValue={"+61"}
                                defaultCountry={"AU"}
                                minLength={15}
                                maxLength={15}
                                onBlur={handleBlur}
                                className={
                                  errors?.mobile &&
                                  `focus-visible:ring-red-500 border-red-500`
                                }
                              />
                            </div>

                            <div className="grid gap-2">
                              <Label htmlFor="organization_id">
                                <CustomLabelText
                                  required={true}
                                  labelText="Organization"
                                  errorField={errors?.organization_id}
                                />
                              </Label>
                              <div className="relative">
                                <MultiSelect
                                  options={
                                    organizationData?.organizationList?.length >
                                    0
                                      ? organizationData?.organizationList
                                      : []
                                  }
                                  placeholder={"Organization"}
                                  onValueChange={(e) => {
                                    setFieldValue("organization_id", e);
                                    if (e?.length === 0) {
                                      setFieldValue("office_id", "");
                                    }
                                  }}
                                  handleBlur={handleBlur}
                                  className={
                                    errors?.organization_id &&
                                    `focus-visible:ring-red-500 border-red-500`
                                  }
                                  variant="inverted"
                                  animation={2}
                                  maxCount={2}
                                  defaultValue={values?.organization_id}
                                />
                              </div>
                            </div>

                            <div className="grid gap-2">
                              <Label htmlFor="role_id">
                                <CustomLabelText
                                  required={true}
                                  labelText="Role"
                                  errorField={errors?.role_id}
                                />
                              </Label>

                              <div className="relative">
                                <SearchSelect
                                  frameworks={roleListing}
                                  optionType={"Role"}
                                  handleSelect={(e) => {
                                    setFieldValue("role_id", e);
                                  }}
                                  handleBlur={handleBlur}
                                  className={
                                    errors?.role_id &&
                                    `focus-visible:ring-red-500 border-red-500`
                                  }
                                  disabled={false}
                                  initialValue={values?.role_id}
                                />
                                {roleLoading && (
                                  <span className="absolute top-2 right-2 animate-spin">
                                    <Loader2 width={20} height={20} />
                                  </span>
                                )}
                              </div>
                            </div>

                            <div className="grid gap-2">
                              <Label htmlFor="office_id">
                                <CustomLabelText
                                  required={false}
                                  labelText="Office"
                                  errorField={errors?.office_id}
                                />
                              </Label>
                              <div className="relative">
                                <OfficeSelect
                                  org_id={values?.organization_id} // Pass the selected state ID
                                  frameworkData={officeListing} // List of offices
                                  optionType="Office"
                                  handleSelect={(e) => {
                                    setFieldValue("office_id", e);
                                  }}
                                  name="office_id"
                                  handleBlur={handleBlur}
                                  className={
                                    errors?.office_id &&
                                    `focus-visible:ring-red-500 border-red-500`
                                  }
                                  disabled={
                                    values?.organization_id?.length === 0
                                  }
                                  initialValue={values?.office_id}
                                  setOfficeList={setOfficeList} // Update suburb list as new data loads
                                  setOfficeLoading={setOfficeLoading} // Control loading state
                                />
                                {officeLoading && (
                                  <span className="absolute top-2 right-2 animate-spin">
                                    <Loader2 width={20} height={20} />
                                  </span>
                                )}
                              </div>
                            </div>

                            <div className="grid gap-2 grid-cols-2 xl:grid-cols-4">
                              <div className="flex items-center space-x-2">
                                <span className="text-sm font-medium">
                                  Compliance Officer
                                </span>
                                <Switch
                                  checked={values?.is_compliance}
                                  onCheckedChange={(e) =>
                                    setFieldValue("is_compliance", e)
                                  }
                                  className="data-[state=checked]:bg-webPrimary"
                                />
                              </div>
                              <div className="flex items-center space-x-2">
                                <span className="text-sm font-medium">
                                  Governing Body
                                </span>
                                <Switch
                                  checked={values?.is_senior_manager}
                                  onCheckedChange={(e) =>
                                    setFieldValue("is_senior_manager", e)
                                  }
                                  className="data-[state=checked]:bg-webPrimary"
                                />
                              </div>
                            </div>

                            <div className="grid gap-2">
                              <Label htmlFor="files">
                                <CustomLabelText
                                  required={false}
                                  labelText="Documents"
                                  errorField={errors?.documents}
                                />
                              </Label>
                              <MultiFileUpload
                                files={files}
                                setFiles={setFiles}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </>{" "}
                  </Step>
                )}
                {/* {edit && amlCTFEnable && (
                  <Step
                    label="Risk Assessments"
                    horizontalStepClassName={"flex flex-col gap-2 font-bold"}
                  >
                    <AssessmentStep
                      mainData={userData}
                      values={values}
                      errors={errors}
                      setFieldValue={setFieldValue}
                      handleBlur={handleBlur}
                      edit={edit}
                      organizationData={organizationData}
                      sectionType={sectionType}
                      setSectionType={setSectionType}
                      validateField={validateField}
                      setTouched={setTouched}
                    />
                  </Step>
                )} */}

                {edit && amlCTFEnable && (
                  <Step
                    label="Verifications"
                    horizontalStepClassName={"flex flex-col gap-2 font-bold"}
                  >
                    <VerificationStep
                      loading={loading}
                      mainData={userData}
                      values={values}
                      errors={errors}
                      handleBlur={handleBlur}
                      setFieldValue={setFieldValue}
                      handleChange={handleChange}
                      organizationData={organizationData}
                      edit={edit}
                      verificationMethods={verificationMethods}
                      verificationTypes={verificationTypes}
                      setVerificationTypes={setVerificationTypes}
                      setLoading={setLoading}
                      fetchData={fetchData}
                      user={userId ? userId : false}
                      stateListing={stateListing}
                      stateLoading={stateLoading}
                    />
                  </Step>
                )}
              </Stepper>
            </div>

            <div className="modal-footer pt-4 border-t mt-4 flex items-center justify-end">
              <Button type="submit" disabled={!isValid}>
                {stepsData?.length - 1 === currentStep ? "Save" : "Save & Next"}
              </Button>
              {currentStep !== 0 && (
                <Button
                  className="reset ml-3"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={(e) => {
                    e.preventDefault();
                    setCurrentStep(Number(Number(currentStep) - 1));
                  }}
                  variant="secondary"
                >
                  Previous
                </Button>
              )}
              <Button
                className="reset ml-3"
                data-dismiss="modal"
                aria-label="Close"
                onClick={(e) => {
                  e.preventDefault();
                  toggleShowAddEditUser();
                }}
                variant="secondary"
              >
                Cancel
              </Button>
            </div>
          </form>
        </>
      )}
    </Formik>
  );
};

export default AddEditUser;
